import axios from "axios";

export const UpdateNews = async (payload) => {
  const token = JSON.parse(localStorage.getItem("authentication"));
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_API}/api/news/UpdateNews`,
      payload,
      config
    );
    return { status: 200, payload: data };
  } catch (error) {
    console.error("UpdateNews error:", error);
    const status = error?.response?.status || 500;
    return { status, payload: null };
  }
};
